import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Form,
  Label,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"
import { CSVLink } from "react-csv"

function Ventures() {
  const [Actin, setActin] = useState([])
  const [filter, setFilter] = useState(false)
  const [filters, setFilters] = useState({ community: "", categoryName: "" })
  const history = useHistory()
  const [communities, setCommunities] = useState([])
  const [categories, setcategories] = useState([])
  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token
  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)
  const token = JSON.parse(localStorage.getItem("authUser"))?.token
  useEffect(() => {
    GetUsers()
    datass()
    fetchCommunities()
    GetAllCategories()
  }, [])

  const GetUsers = () => {
    var token = datas
    axios
      .post(
        URLS.RejectedVendorListing,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setActin(res.data.rejectedvendorlistings)
      })
  }

  const pagesVisited = pageNumber * listPerPage
  const lists = Actin.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Actin.length / listPerPage)

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const Actinid1 = data => {
    sessionStorage.setItem("ListingId", data.serviceId)
    history.push("/ViewVendorListing")
  }

  const datass = () => {
    const location = sessionStorage.getItem("tost")
    if (location != "") {
      toast(location)
      sessionStorage.clear()
    } else {
      sessionStorage.clear()
    }
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)

  const [Searchs, setSearchs] = useState([])

  const Search = e => {
    let myUser = { ...Searchs }
    myUser[e.target.name] = e.target.value
    setSearchs(myUser)
    var token = datas
    axios
      .post(
        URLS.RejectedVendorListingSearch + `${e.target.value}`,
        {},

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setActin(res.data.rejectedvendorlistings)
      })
  }

  const handleChangeflt = e => {
    const { name, value } = e.target
    setFilters(prev => ({ ...prev, [name]: value }))
  }

  const getfilter = e => {
    e.preventDefault()
    GetOrderFilter()
  }

  const GetOrderFilter = () => {
    const bodyData = {
      community: filters.community,
      categoryName: filters.categoryName,
    }

    axios
      .post(URLS.RejectedVendorListing, bodyData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setActin(res.data.rejectedvendorlistings)
        hideFilter()
        setFilters({ community: "", categoryName: "" })
      })
      .catch(err => console.error(err))
  }

  const hideFilter = () => setFilter(false)

  // communities
  const fetchCommunities = () => {
    axios
      .post(
        "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/community/getall",
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.data.success) {
          const userCommunityObjects = res.data.usercommunities.map(
            (community, index) => ({
              _id: `user_${index}`,
              community: community,
            })
          )

          // Combining the communities and user communities
          const allCommunities = [
            ...(res.data.communities || []),
            ...userCommunityObjects,
          ]

          setCommunities(allCommunities)
        } else {
          toast(res.data.message)
        }
      })
  }

  // categories
  const GetAllCategories = () => {
    axios
      .post(
        "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/category/getallcategorys",
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.data.success) {
          setcategories(res.data.category)
        } else {
          toast(res.data.message)
        }
      })
  }

  const handleReset = () => {
    // setSearchs({ name: "", email: "", phone: "" })
    setFilters({ community: "", categoryName: "" })
    setPageNumber(0)
    GetUsers()
  }

  const manageDelete = (data) => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      Delete(data)
    }
  }

  const Delete = (datau) => {
    var token = datas
    var remid = datau.serviceId
    axios
      .post(
        "https://api.jaininternationalnetwork.com//v1/a2zsolutionsapi/admin/service/deleteservice/" +
          remid,{},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            GetUsers()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  // excel funtionality
  const headers2 = [
    { label: "S.No", key: "sno" },
    { label: "Listing ID", key: "listingCode" },
    { label: "Listing Name", key: "listingName" },
    { label: "Business Man Name	", key: "name" },
    { label: "phone", key: "phone" },
    { label: "Email", key: "email" },
    { label: "Community", key: "community" },
    { label: "Reject Reason", key: "rejectedReason" },
    { label: "ListingStatus", key: "listingStatus" },
  ]

  const csvData = Actin.map((elt, i) => ({
    sno: i + 1,
    listingCode: elt.listingCode,
    listingName: elt.listingName,
    name: elt.name,
    phone: elt.phone,
    email: elt.email,
    community: elt.community,
    rejectedReason: elt.rejectedReason,
    listingStatus: elt.listingStatus,
  }))

  const csvReport = {
    filename: "RejectedBusinessManListing.csv",
    headers: headers2,
    data: csvData,
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Home"
            breadcrumbItem="Rejected Business Man listing"
          />
          {filter && (
            <Card>
              <CardBody>
                <Form onSubmit={getfilter}>
                  <Row>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="community-filter">Community</Label>
                        <select
                          id="community-filter"
                          className="form-select"
                          value={filters.community}
                          name="community"
                          onChange={handleChangeflt}
                        >
                          <option value="">Select</option>
                          {communities.map((community, index) => (
                            <option key={index} value={community.community}>
                              {community.community}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="category-filter">Category</Label>
                        <select
                          id="category-filter"
                          className="form-select"
                          value={filters.categoryName}
                          name="categoryName"
                          onChange={handleChangeflt}
                        >
                          <option value="">Select</option>
                          {categories.map((category, index) => (
                            <option key={index} value={category.name}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mt-4">
                        <Button type="submit" className="m-1" color="info">
                          <i className="fas fa-check-circle"></i> Search
                        </Button>
                        <Button
                          onClick={hideFilter}
                          className="m-1"
                          color="danger"
                        >
                          <i className="fas fa-times-circle"></i> Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          )}
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <Button
                        className="m-1"
                        onClick={() => setFilter(!filter)}
                        color="info"
                      >
                        <i className="fas fa-filter"></i> Filter
                      </Button>
                      <Button
                        className="m-1"
                        onClick={handleReset}
                        color="info"
                      >
                        <i className="fas fa-sync-alt"></i> Reset
                      </Button>
                      <CSVLink {...csvReport}>
                        <button
                          className="btn btn-success me-2 m-1"
                          type="button"
                        >
                          <i className="fas fa-file-excel"></i> Excel
                        </button>
                      </CSVLink>
                    </Col>
                    <Col>
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          name="search"
                          value={Searchs.search}
                          onChange={Search}
                          className="form-control"
                          placeholder="Search.."
                          autoComplete="off"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover className="table table-bordered mb-4">
                      <thead>
                        <tr className="text-center">
                          <th>SlNo</th>
                          <th>Listing Id</th>
                          <th>Listing Name</th>
                          <th>Business Man Name</th>
                          <th>Phone</th>
                          <th>Email</th>
                          <th>Community</th>
                          <th>Business Type </th>
                          <th>Reject Reason</th>
                          <th>Status</th>
                          <th style={{ width: "300px" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => (
                          <tr key={key} className="text-center">
                            <td>{(pageNumber - 1) * 5 + key + 6}</td>
                            <td>
                              <a
                                className="text-primary"
                                onClick={() => {
                                  Actinid1(data)
                                }}
                              >
                                {data.listingCode}
                              </a>
                            </td>
                            <td>{data.listingName}</td>
                            <td>{data.name}</td>
                            <td>{data.phone}</td>
                            <td>{data.email}</td>
                            <td>{data.community}</td>
                            <td>
                              {data.vendor == false ? (
                                <>{"Business"}</>
                              ) : (
                                <>{"Business"}</>
                              )}
                            </td>
                            <td>{data.rejectedReason}</td>
                            <td>
                              <span className="badge bg-danger">
                                {data.listingStatus}
                              </span>
                            </td>
                            <td style={{ width: "300px" }}>
                              <Button
                                onClick={() => {
                                  Actinid1(data)
                                }}
                                className="m-1 btn-sm"
                                color="info"
                              >
                                <div className="d-flex">
                                  <small className="d-flex">
                                    <i className="fas fa-eye m-1"></i> View
                                  </small>
                                </div>
                              </Button>
                              <Button
                                className="m-1 btn-sm"
                                color="danger"
                                onClick={() => {
                                  manageDelete(data)
                                }}
                              >
                                <div className="d-flex">
                                  <small className="d-flex">
                                    <i className="bx bx-trash px-1"></i>
                                    Delete
                                  </small>
                                </div>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div
                      className="d-flex mt-3 mb-1"
                      style={{ float: "right" }}
                    >
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={"pagination"}
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                        total={lists.length}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Ventures
